<template>
  <div>
    <PageTitleVue
      :sub-title="'Adicione uma nova turma'"
    >
      Alterar Turma

      <!-- go back -->
      <template #b-action>
        <Create
          @click="router.push('/fighters')"
          :icon="PhArrowLeft"
          :label="'Voltar'"
          :menu-active="'Lutadores'"
        />
      </template>

    </PageTitleVue>

    <Form
      id="form-fields"
      :descriptionTitle="'Dados do grupo'"
      :create="false"
    >
      <div class="w-full flex justify-center mt-4">
        <CreateButton
          @click="updateGroup"
          :icon="'fa-solid fa-user-plus'"
          :label="'Salvar'"
        />
      </div>
    </Form>
  </div>
</template>

<script setup>
import PageTitleVue from '@/components/Titles/PageTitle.vue'
import CreateButton from '@/components/Buttons/Create.vue'
import Create from '@/components/Buttons/Create.vue'
import Form from './GroupForm.vue'
import * as yup from '@/validator'
import router from '@/router'
import { storeApp } from '@/store'
import { setFormFieldsError, validateFormField } from '@/helpers/formFieldsHandler'
import { onBeforeMount } from 'vue'
import { showToast as toast } from '@/helpers/UseToasts'
import { useRoute } from 'vue-router'
import { PhArrowLeft } from '@phosphor-icons/vue'

import { dataGroups } from '../store/groups'
import groupService from '../services/group.service'

const group_id = useRoute().params.id
const appStore = storeApp
const store = dataGroups

const form = yup.object().shape({
  name: yup.string().required('Informe o nome da turma').label('Turma').min(3).max(100)
})

onBeforeMount(async () => {
  store.commit('RESET_FORM')
  appStore.state.loading = true
  await getGroupById()
  appStore.state.loading = false
})

async function getGroupById () {
  await groupService.groupById(group_id)
    .then(res => {
      console.log(res.data)

      store.commit('UPDATE_FIELDS_FORM', res.data)
    }).catch(err => {
      console.log(err)

      toast(
        'Erro',
        'Algo deu arrado ao buscar dados da turma',
        'error'
      )
    })
}

async function updateGroup () {
  appStore.state.loading = true

  const validate = (await validateFormField(form, store.state.form))
  if (validate && validate.length > 0) {
    setFormFieldsError(validate)
    appStore.state.loading = false
    console.log(validate)

    toast(
      'Aviso',
      'Campos obrigatórios não preenchidos',
      'error'
    )

    return
  }

  const data = Object.assign({}, store.state.form)

  await groupService.editGroup(group_id, data)
    .then(res => {
      appStore.state.loading = false
      if (res.data.success) {
        toast(
          'Sucesso',
          res.data.message,
          'success'
        )
      }
    })
    .catch(err => {
      appStore.state.loading = false

      toast(
        'Erro',
        err.response.data.message,
        'error'
      )
    })
}

</script>

<style lang="scss">
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
